import styled from "styled-components";
import { Button, Col, Select, Modal, Input, Table } from "antd";

import colors from "../../../../../../../../themes/colors";

export const StyledModal = styled(Modal)`
  top: 20px;
`;

export const ListScrollContainer = styled.div`
  height: 445px;
  border-top: 1px solid ${colors.veryLightGrey};
  border-bottom: 1px solid ${colors.veryLightGrey};
  margin: 24px -24px; /* use negative margin to make the list full-width in modal */
  overflow-y: scroll;
`;

export const SpinContainer = styled.div`
  padding: 283px 0 282px;
  text-align: center;
`;

export const StyledSelect: typeof Select = styled(Select)`
  width: 300px;
`;

export const ElsterCodeCol = styled(Col)`
  padding-left: 18px;
`;

export const AmountCol = styled(Col)`
  text-align: right;
  padding-right: 18px;
  white-space: nowrap;
`;

export const Error = styled.div`
  color: ${colors.darkRed};
  padding: 10px 0px;
  font-weight: bold;
`;

export const AmountInputWrapper = styled.div`
  text-align: right;
  padding: 5px 11px 5px 0;
  height: 32px;
  border: 1px solid transparent;
  border-radius: 2px;
  transition: border-color 0.3s;

  &.editable:hover {
    border-color: ${colors.midLightGrey};
  }
`;

export const StyledInput = styled(Input)`
  text-align: right;
`;

export const CheckBlock = styled.div`
  text-align: right;
  white-space: nowrap;
  font-size: 12px;
  line-height: 18px;
`;

export const CheckLinkButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  height: auto;
  padding: 0;
  font-size: inherit;

  .ant-btn-loading-icon {
    display: inline-flex;
    align-items: center;
  }

  .ant-btn-loading-icon .anticon {
    vertical-align: 0;
  }
`;

export const CheckMatch = styled.span`
  color: ${colors.darkLimeGreen};
`;

export const CheckMismatch = styled.span`
  color: ${colors.darkOrange};
`;

export const CheckBoxCol = styled(Col)`
  margin-top: 4px;
  margin-bottom: 4px;
  min-width: 0;
  /* Same right padding as the AmountCol above, so the box ends under the amount. */
  padding-right: 18px;
`;

// Colours follow the antd success/warning alert palette.
const BOX_COLORS = {
  success: { background: "#f6ffed", border: "#b7eb8f" },
  warning: { background: "#fffbe6", border: "#ffe58f" },
  info: { background: "#e6f7ff", border: "#91d5ff" },
};

export const CheckBox = styled.div<{ $type: "success" | "warning" | "info" }>`
  padding: 6px 12px;
  font-size: 14px;
  line-height: 22px;
  background: ${({ $type }) => BOX_COLORS[$type].background};
  border: 1px solid ${({ $type }) => BOX_COLORS[$type].border};
  border-radius: 2px;
`;

export const CheckTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: normal;

  .anticon {
    font-size: 14px;
  }
`;

export const CheckNetBlock = styled.div`
  margin-top: 6px;
  font-size: 14px;
`;

export const CheckNetGrid = styled.div`
  display: grid;
  margin-top: 6px;
  grid-template-columns: max-content minmax(0, 1fr);
  column-gap: 12px;
  overflow-wrap: anywhere;
`;

export const CheckNetRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
  font-size: 14px;

  .anticon {
    font-size: 14px;
  }
`;

export const CheckTable = styled(Table)`
  margin-top: 4px;
  background: transparent;

  .ant-table {
    background: transparent;
    font-size: 14px;
  }

  .ant-table-small .ant-table-thead > tr > th,
  .ant-table-small .ant-table-tbody > tr > td {
    padding: 4px 8px;
  }

  .ant-table-thead > tr > th {
    background: transparent;
  }

  td,
  th {
    white-space: normal;
  }
` as typeof Table;

export const CheckFooter = styled.div`
  margin-top: 6px;
  font-size: 12px;
  color: ${colors.lightGreyOpacity};
`;
